import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initDb } from './services/idb';
import { primeSettingsCache } from './services/db';
import { initOps } from './services/ops';
import { initSync } from './services/sync';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Storage is IndexedDB (services/idb.ts). Open it, run the one-time import from
// localStorage and fill the synchronous settings caches BEFORE the first render,
// so components read real data (and settings) from the very first paint.
async function bootstrap() {
  try {
    await initDb();
    await primeSettingsCache();
    // Load the op-sync version map before any mutation can emit an op.
    await initOps();
    // Start LAN sync if it was left enabled (registers the op sink + seq
    // provider and connects to the server).
    initSync();
  } catch (err) {
    // Never leave a blank screen if storage init fails — render anyway; the app
    // starts empty and surfaces errors as they occur.
    console.error('Storage initialisation failed:', err);
  }
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

bootstrap();